Postlogin = (function (self) {
    self.SelectAvatar = {};
    const me = self.SelectAvatar;

    me.init = function () {
        $('.filter-avatars-button-group')
            .find('button')
            .on('click', (e) => {
                const filter = $(e.currentTarget).data('filter');
                const avatarList = $('.avatars');
                const filterOut = function () {
                    avatarList.find('.avatar').removeClass('animated zoomIn').addClass('animated zoomOut').hide();
                    avatarList.find(filter).removeClass('animated zoomOut').addClass('animated zoomIn').show();
                };

                if (filter === '*') {
                    avatarList.find('.avatar').hide().removeClass('animated zoomOut').addClass('animated zoomIn')
                        .show();
                } else {
                    filterOut();
                }
            });

        $('.avatars').keypress('.avatar', (e) => {
            if (+e.which === 13 || +e.which === 32) {
                $(e.target).trigger('click');
            }
        });

        $('.avatars').on('click', '.avatar', function (e) {
            e.preventDefault();
            if ($(this).hasClass('selected')) {
                return;
            }
            $('#ajax-progress-indicator').fadeIn();
            const avatarId = $(this).attr('data-avatar-id');
            const path = $(this).find('img').attr('src');

            $.post(`${window.location.href.split('#')[0].replace(/\/?$/, '/')}set/${avatarId}/`, () => {
                $('#ajax-progress-indicator').fadeOut();
                $('.avatar.selected').removeClass('selected');
                $(`#avatar-${avatarId}`).addClass('selected');

                const sourceOffset = $(`#avatar-${avatarId} > img`).offset();
                const targetOffset = $('#dashboard-sidebar .avatar-container > img').offset();
                const targetWidth = $('#dashboard-sidebar .avatar-container > img').outerWidth();
                const targetHeight = $('#dashboard-sidebar .avatar-container > img').outerHeight();

                const newAvatar = $('<img />')
                    .attr('id', 'animating-avatar')
                    .attr('src', path)
                    .css('top', `${sourceOffset.top - $(window).scrollTop()}px`)
                    .css('left', `${sourceOffset.left}px`);

                $(newAvatar).appendTo($('body'));

                $(newAvatar).animate(
                    {
                        width: `${targetWidth * 3}px`,
                        height: `${targetHeight * 3}px`,
                        'border-width': '10px',
                    },
                    300,
                    () => {
                        $(newAvatar).animate(
                            {
                                width: `${targetWidth}px`,
                                height: `${targetHeight}px`,
                                'border-width': '6px',
                            },
                            { queue: false, duration: 500 },
                        );
                    },
                );

                $(newAvatar).animate(
                    {
                        opacity: 1,
                        top: `${targetOffset.top - $(window).scrollTop()}px`,
                        left: `${targetOffset.left}px`,
                    },
                    {
                        queue: false,
                        duration: 800,
                        done() {
                            $('img.avatar').attr('src', path);
                            $('#animating-avatar').fadeOut(500, () => {
                                $('#animating-avatar').remove();
                            });
                        },
                    },
                );
            });
        });
    };

    return self;
}(Postlogin || {}));
